/* eslint-disable react/prop-types */
import React from 'react';
import { Address_text } from '../../constant/Translation/Address';
import Edit_address_button from './Edit_address';

const ShippingAddresses = ({
  addresses,
  selectShippingAddress,
  setSelectShippingAddress,
}) => {
  return (
    <div className=" bg-white w-full   md:w-[768px] min-h-[200px] rounded-card shadow-c-xsm px-5 md:px-[38px] pb-10 grid items-center gap-4">
      <div className="w-ful flex items-center justify-center py-4">
        <p className="text-primary text-xl leading-6 font-medium ">
          {Address_text.address.shipping_address}
        </p>
      </div>
      {addresses?.length > 0 ? (
        addresses?.map((location) => {
          return (
            <div
              key={Math.random()}
              // onClick={() => setSelectShippingAddress(location)}
              className={
                '  mb-3  w-full  min-h-[81px] flex   justify-between  p-[16px] border   transition-all duration-1000	    border-transparent   rounded-card   ring-2 ring-primary ring-offset-2  shadow-md '
              }
            >
              <div className=" flex-grow flex justify-start items-start gap-1 md:gap-2">
                <svg
                  width="18"
                  height="22"
                  viewBox="0 0 18 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex-none"
                >
                  <path
                    d="M17.4604 8.62982C17.32 7.16873 16.8036 5.7689 15.9616 4.56664C15.1195 3.36437 13.9805 2.40065 12.6554 1.76931C11.3303 1.13798 9.86425 0.860541 8.40008 0.964024C6.93592 1.06751 5.5235 1.54838 4.30037 2.35982C3.24957 3.06247 2.36742 3.98912 1.71731 5.07321C1.0672 6.1573 0.665264 7.37193 0.540369 8.62982C0.417852 9.87948 0.575043 11.1407 1.00054 12.3221C1.42604 13.5035 2.10917 14.5753 3.00037 15.4598L8.30037 20.7698C8.39333 20.8636 8.50393 20.9379 8.62579 20.9887C8.74765 21.0395 8.87836 21.0656 9.01037 21.0656C9.14238 21.0656 9.27309 21.0395 9.39495 20.9887C9.51681 20.9379 9.62741 20.8636 9.72037 20.7698L15.0004 15.4598C15.8916 14.5753 16.5747 13.5035 17.0002 12.3221C17.4257 11.1407 17.5829 9.87948 17.4604 8.62982ZM13.6004 14.0498L9.00037 18.6498L4.40037 14.0498C3.72246 13.3719 3.20317 12.5521 2.87984 11.6496C2.5565 10.747 2.43715 9.78402 2.53037 8.82982C2.62419 7.86092 2.93213 6.92498 3.43194 6.08966C3.93175 5.25435 4.61093 4.54053 5.42037 3.99982C6.48131 3.29506 7.72668 2.91912 9.00037 2.91912C10.2741 2.91912 11.5194 3.29506 12.5804 3.99982C13.3874 4.53844 14.065 5.2491 14.5647 6.08076C15.0644 6.91242 15.3737 7.84442 15.4704 8.80982C15.5666 9.76725 15.4488 10.7341 15.1254 11.6404C14.8019 12.5466 14.281 13.3697 13.6004 14.0498ZM9.00037 4.99982C8.11035 4.99982 7.24032 5.26374 6.5003 5.75821C5.76028 6.25267 5.18351 6.95548 4.84291 7.77775C4.50232 8.60001 4.4132 9.50481 4.58684 10.3777C4.76047 11.2506 5.18905 12.0525 5.81839 12.6818C6.44773 13.3111 7.24955 13.7397 8.12246 13.9134C8.99538 14.087 9.90018 13.9979 10.7224 13.6573C11.5447 13.3167 12.2475 12.7399 12.742 11.9999C13.2364 11.2599 13.5004 10.3898 13.5004 9.49982C13.4977 8.30716 13.0228 7.1641 12.1794 6.32076C11.3361 5.47742 10.193 5.00246 9.00037 4.99982ZM9.00037 11.9998C8.50592 11.9998 8.02257 11.8532 7.61144 11.5785C7.20032 11.3038 6.87989 10.9133 6.69067 10.4565C6.50145 9.99971 6.45194 9.49705 6.54841 9.01209C6.64487 8.52714 6.88297 8.08169 7.2326 7.73205C7.58223 7.38242 8.02769 7.14432 8.51264 7.04786C8.9976 6.95139 9.50026 7.0009 9.95708 7.19012C10.4139 7.37934 10.8043 7.69977 11.079 8.1109C11.3537 8.52202 11.5004 9.00537 11.5004 9.49982C11.5004 10.1629 11.237 10.7987 10.7681 11.2676C10.2993 11.7364 9.66341 11.9998 9.00037 11.9998Z"
                    fill="#121212"
                  />
                </svg>

                <div className="ltr:ml-[10px] rtl:mr-[10px] ">
                  <p className="text-base leading-4   font-semibold">
                    {location?.name}
                  </p>
                  <p className="text-base leading-4   font-medium ">
                    {location?.country}
                  </p>
                  <p className=" text-xs leading-4 font-medium    w-[95%] md:w-[225px]   mt-[2px]">
                    {location?.formatted_address}
                  </p>
                </div>
              </div>
              <div className=" flex-none flex justify-center items-center  float-right">
                <Edit_address_button
                  address_details={location}
                  _type={'shipping'}
                />
              </div>
            </div>
          );
        })
      ) : (
        <p className="text-primary text-lg leading-6 font-medium ">
          {Address_text.address.no_address_found}
        </p>
      )}
    </div>
  );
};

export default ShippingAddresses;
